export default __webpack_public_path__ + "static/media/9codeinebaby.69802aff.mp3";